import { defineComponent as _defineComponent } from 'vue'
import useHttpRequest from "@/composables/use-http-request";
import { useShowWarningMessage } from "@/composables/use-notifications";
import Student from "@/interfaces/student.interface";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'change-password.component',
  props: {
    student: null
  },
  setup(__props: any) {



const oldPassword = ref("");
const newPassword = ref("");
const confirmNewPassword = ref("");

//Password visibility
const oldPasswordVisibility = ref("password");
const newPasswordVisibility = ref("password");
const confirmNewPasswordVisibility = ref("password");

const clearInputs = () => {
  oldPassword.value = "";
  newPassword.value = "";
  confirmNewPassword.value = "";
};

const validateInput = () => {
  if (oldPassword.value === "") {
    return useShowWarningMessage(
      "Old password required",
      "Please provide a the old password"
    );
  }
  if (newPassword.value === "") {
    return useShowWarningMessage(
      "New password required",
      "Please provide the new password"
    );
  }
  if (confirmNewPassword.value === "") {
    return useShowWarningMessage(
      "Confirm new password",
      "Please provide confirmation confirmation"
    );
  }
  if (confirmNewPassword.value !== newPassword.value) {
    return useShowWarningMessage(
      "Password Mismatch",
      "Please make sure the new passwords match"
    );
  }
  return true;
};

const changePassword = async () => {
  if (validateInput() !== true) {
    return;
  }
  const request = await useHttpRequest<{ success: boolean; message: string }>({
    method: "PUT",
    url: "students/change-password",
    loadingProperty: null,
    showSuccessMessage: true,
    showFullScreenLoader: true,
    body: {
      oldPassword: oldPassword.value,
      newPassword: newPassword.value,
    },
  });

  if (!request) return;
  if (request.success && request.message == "Password Changed Successfully") {
    clearInputs();
  }
};

return { __sfc: true,oldPassword, newPassword, confirmNewPassword, oldPasswordVisibility, newPasswordVisibility, confirmNewPasswordVisibility, clearInputs, validateInput, changePassword }
}

})